import React, { useState } from "react";
import { Grid, Tabs, Tab, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import DoneAllIcon from "@mui/icons-material/DoneAll";

import { BillingTypeEnum } from "../types/insuranceBills.types";
import { InsuranceBillsContainer } from "../components/InsuranceBillsContainer";
import InsuranceAnalyticsContainer from "../components/analytics/InsuranceAnalyticContainer";
import { mobiliTheme } from "../../../../../themes/mobiliTheme";

export enum BillingStatus {
  START = "START",
  OPEN = "OPEN",
  PREVIOUS = "PREVIOUS",
}

const InsurancePageLayout: React.FC = () => {
  // GKV / PAPIER / ZUZAHLUNG / ANALYTIK / KORREKTUR
  const [billingType, setBillingType] = useState<BillingTypeEnum>(BillingTypeEnum.GKV);

  // START / OPEN / PREVIOUS
  const [billStatus, setBillStatus] = useState<BillingStatus>(BillingStatus.START);

  return (
    <div
      style={{
        marginTop: 20,
      }}
    >
      {/* billing type tabs */}
      <Grid
        container
        sx={{ flexShrink: 0 }}
      >
        <Grid
          item
          xs={6}
        >
          <Tabs
            value={billingType}
            onChange={(_, v) => setBillingType(v as BillingTypeEnum)}
            aria-label="billing-type-tabs"
          >
            <Tab
              label="GKV"
              value={BillingTypeEnum.GKV}
            />
            <Tab
              label="PAPIER"
              value={BillingTypeEnum.PAPER}
            />
            <Tab
              label="ZUZAHLUNG"
              value={BillingTypeEnum.ZUZAHLUNG}
            />
            <Tab
              label="KORREKTUR"
              value={BillingTypeEnum.CORRECTION}
            />
            <Tab
              label="POSITIONSKORREKTUR"
              value={BillingTypeEnum.LINE_ITEM_CORRECTION}
            />
            <Tab
              label="ANALYTIK"
              value={BillingTypeEnum.ANALYTIC}
            />
            {/* Add other billing types if needed */}
          </Tabs>
        </Grid>
        <Grid
          item
          xs={6}
          style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
        >
          {billingType !== BillingTypeEnum.ANALYTIC && (
            <ToggleButtonGroup
              value={billStatus}
              exclusive
              size="small"
              onChange={(_, v) => v !== null && setBillStatus(v)}
              sx={{ backgroundColor: "#f5f5f5" }}
            >
              <Tooltip title="Start - Erstellte Rechnungen" arrow placement="top">
                <ToggleButton
                  value={BillingStatus.START}
                  sx={{
                    border: "1px solid #111517",
                    color: "#666",
                    "&.Mui-selected": {
                      backgroundColor: mobiliTheme.palette.info.main,
                      color: "white",
                      "&:hover": {
                        backgroundColor: mobiliTheme.palette.info.dark,
                      },
                    },
                    "&:hover": {
                      backgroundColor: "#e0e0e0",
                    },
                  }}
                >
                  <EditNoteIcon />
                </ToggleButton>
              </Tooltip>
              <Tooltip title="Open - Exportierte Rechnungen" arrow placement="top">
                <ToggleButton
                  value={BillingStatus.OPEN}
                  sx={{
                    border: "1px solid #111517",
                    color: "#666",
                    "&.Mui-selected": {
                      backgroundColor: mobiliTheme.palette.warning.main,
                      color: "#333",
                      "&:hover": {
                        backgroundColor: mobiliTheme.palette.warning.dark,
                      },
                    },
                    "&:hover": {
                      backgroundColor: "#e0e0e0",
                    },
                  }}
                >
                  <ScheduleSendIcon />
                </ToggleButton>
              </Tooltip>
              <Tooltip title="Previous - Abgeschlossene Rechnungen" arrow placement="top">
                <ToggleButton
                  value={BillingStatus.PREVIOUS}
                  sx={{
                    border: "1px solid #111517",
                    color: "#666",
                    "&.Mui-selected": {
                      backgroundColor: mobiliTheme.palette.success.main,
                      color: "white",
                      "&:hover": {
                        backgroundColor: mobiliTheme.palette.success.dark,
                      },
                    },
                    "&:hover": {
                      backgroundColor: "#e0e0e0",
                    },
                  }}
                >
                  <DoneAllIcon />
                </ToggleButton>
              </Tooltip>
            </ToggleButtonGroup>
          )}
        </Grid>
      </Grid>

      {/* conditional rendering based on billing type */}
      <div
        style={{
          flex: 1,
          overflow: "auto",
          minHeight: 0,
        }}
      >
        {billingType === BillingTypeEnum.ANALYTIC ? (
          <InsuranceAnalyticsContainer />
        ) : (
          <InsuranceBillsContainer
            billingType={billingType}
            billStatus={billStatus}
          />
        )}
      </div>
    </div>
  );
};

export default InsurancePageLayout;
